import { put, call, select, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/clientPortalNotifications";
import {
  getClientNotificationsResponse,
  getClientDropdownNotificationsResponse,
  setClientUnseenNotificationsCount,
  replaceClientNotification,
} from "./actions";
import * as types from "./types";
import { showErrorMsg } from "../../../utils/Helpers";

function* getClientNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getClientPortalNotifications, payload);
    yield put(
      getClientNotificationsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      }),
    );
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

// `background`: the navbar's ask on every page, with no loader and no error toast.
export function* getClientDropdownNotificationsSaga({ payload }) {
  const { background, ...params } = payload;
  try {
    const response = yield call(apis.getClientPortalNotifications, params, { background });
    yield put(getClientDropdownNotificationsResponse(response.data.data));
  } catch (error) {
    if (error.response && !background) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

// Opening the list leaves the badge: it stays while unread notifications remain (PROLINE-4169).
// Only unread ones are marked seen, so each one marked takes one off.
export function* setClientNotificationSeenSaga({ payload }) {
  try {
    const response = yield call(apis.setClientPortalNotificationSeen, payload);
    yield put(replaceClientNotification(response.data.data));
    const count = yield select(
      (state) => state.clientNotifications.unseenNotificationsCount,
    );
    yield put(setClientUnseenNotificationsCount(Math.max(0, (Number(count) || 0) - 1)));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

export default function* ClientNotificationsSagas() {
  yield takeEvery(
    types.GET_CLIENT_NOTIFICATIONS_REQUEST,
    getClientNotificationsSaga,
  );
  yield takeEvery(
    types.GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST,
    getClientDropdownNotificationsSaga,
  );
  yield takeEvery(
    types.SET_CLIENT_NOTIFICATION_SEEN,
    setClientNotificationSeenSaga,
  );
}
